import {
  teamsDarkTheme as fluentTeamsDarkTheme,
  teamsHighContrastTheme as fluentTeamsHighContrastTheme,
  teamsLightTheme as fluentTeamsLightTheme,
} from '@fluentui/react-components';

import { createCoreUIFluentTheme } from './createFluent9Theme';

export const teamsLightTheme = createCoreUIFluentTheme(fluentTeamsLightTheme);
export const teamsDarkTheme = createCoreUIFluentTheme(fluentTeamsDarkTheme);
export const teamsHighContrastTheme = createCoreUIFluentTheme(fluentTeamsHighContrastTheme);
